import React from 'react';
import { Text, Flex, Seo, Layout, Wrapper } from '../components';

const NotFoundPage = () => (
  <Layout>
    <Seo title="404 — Not found" />
    <Wrapper>
      <Flex
        minHeight="90vh"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Text as="h2" mb={3} textAlign="center">
          No Results Found
        </Text>
        <Text textAlign="center" color="grey.v5">
          The page you requested could not be found. Try refining your search,
          or use the navigation above to locate the post.
        </Text>
      </Flex>
    </Wrapper>
  </Layout>
);

export default NotFoundPage;
